<div class="flex h-screen bg-gray-50">
  <app-side-nav></app-side-nav>
  <main role="main" class="flex-1 overflow-y-auto">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- Loading Animation -->
@if (loadingService.isLoading()) {
  <app-loading [isLoading]="isLoading()"></app-loading>
}

<!-- Notifications -->
<div class="fixed top-6 z-[9999] w-full max-w-sm sm:right-40 flex flex-col gap-4">
  @for (notification of notifications(); track notification.id) {
    <app-notification-alert
      [type]="notification.type"
      [message]="notification.message"
      [isLeaving]="notification.isLeaving"
      (close)="notificationService.startLeaveAnimation(notification.id)"
      class="transform transition-all duration-500 ease-in-out">
    </app-notification-alert>
  }
</div>
